import { Ctrl } from "@yuigoto/ctrl";
import React from "react";

export class ExtendedControl extends Ctrl{
  /**
   * @type {React.Component|React.FunctionComponent}
   */
  component = null;
  
  /**
   * 
   * @param {import("@yuigoto/ctrl").CtrlProps} props 
   * @param {{
   *   component: React.Component|React.FunctionComponent 
   * }} options 
   */
  constructor(props, options={}){
    super(props);

    for(const key of Object.keys(options)){
      this[key] = options[key];
    }
  }
}